import { useCookie, useRuntimeConfig } from "#imports";
import { useSiteUtils } from "@voix/composables/useSiteUtils";
import { useVoixToast } from "@voix/composables/useVoixToast";
import { useAdminStore } from "@voix/store/adminStore";
export default async function $voixFetch(request, options = {}) {
  const config = useRuntimeConfig();
  const { getCurrentDomain } = useSiteUtils();
  const domain = getCurrentDomain();
  const headers = {
    "X-VOIX-SITE": domain,
    "accept": "application/json"
  };
  const adminStore = useAdminStore();
  const releasePreviewHeader = adminStore.releaseId;
  if (releasePreviewHeader)
    headers["X-VOIX-RELEASE-PREVIEW"] = releasePreviewHeader;
  const accessToken = useCookie("auth-access-token");
  if (accessToken.value && (request.includes("api/admin") || options?.sendAuthHeader === true))
    headers.authorization = `Bearer ${accessToken.value}`;
  const theRequest = await $fetch(
    `${config.public.voixApiBaseUrl}${request}`,
    {
      ...options,
      headers: {
        ...headers,
        ...options?.headers
      }
    }
  ).catch((error) => {
    const voixToast = useVoixToast();
    switch (error.statusCode) {
      case 401:
        console.warn("Voix Nuxt API: Route to login");
        break;
      case 422:
        if (error.data?.errors) {
          Object.keys(error.data?.errors).forEach((key) => {
            error.data?.errors[key].forEach((validationError) => {
              voixToast.add(validationError, "error");
            });
          });
        } else {
          voixToast.add(error.message, "error");
        }
        break;
      default:
        if (error?.data && error?.data?.message)
          voixToast.add(error.data.message, "error");
        else
          voixToast.add(error.message, "error");
        break;
    }
    throw error;
  });
  return theRequest;
}
